import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomizedDialog from '../Dialog/CustomizedDialog';
import { alertActions } from '../../modules/alert';

class ContentsVolume extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            contentVolume: props.contentVolume,
            contentsTypeCode: props.contentsTypeCode,
        }
    }

    // 음소거 버튼 
    handleMuteButton = () => {
        this.setState({
            contentVolume: this.state.contentVolume === 0 ? 0.5 : 0,
        });
    };

    // 볼륨 조절
    handleVolumeChange = (e) => {
        this.setState({
            contentVolume: e.target.value / 100,
        });
    };

    handleFormSubmit = (e) => {
        e.preventDefault();

        this.props.handleContentVolumeChange(this.state.contentVolume);
        this.handleClose();
    }

    handleClickOpen = () => {
        this.setState({
            open: true,
            contentVolume: this.props.contentVolume,
            contentsTypeCode: this.props.contentsTypeCode,
        });
    };

    handleClose = () => {
        this.setState({
            open: false,
        });
    };

    render() {
        const { open, contentsTypeCode } = this.state;
        let boardType = "";
        if (contentsTypeCode === "CT002") boardType = "상단영상 볼륨";
        else if (contentsTypeCode === "CT003") boardType = "중앙영상 볼륨";
        else if (contentsTypeCode === "CT004") boardType = "하단영상 볼륨";

        return (
            <>
                <button className="blue-button w96-button s-icon-speaker" onClick={this.handleClickOpen}>볼륨조절</button>
                <CustomizedDialog title={boardType + " 설정"} open={open} handleClose={this.handleClose}>
                    <div className="dialog-content opbState-mng-add">
                        <div className="s-flex-auto">
                            <div className="s-set-range">
                                <div className="s-set-item" style={{ padding: "15px 15px 15px 15px" }}>
                                    <div className="s-range-box s-volume s-flex-box">
                                        <div className="s-volume-control s-flex-none" onClick={this.handleMuteButton}>
                                            {this.state.contentVolume !== 0
                                                ?
                                                <img alt="볼륨켜짐" src="/assets/images/ic-volume-on.png" />
                                                :
                                                <img alt="볼륨꺼짐" src="/assets/images/ic-volume-off.png" />
                                            }
                                        </div>
                                        <input className="s-flex-auto" type="range" name="contentVolume" value={this.state.contentVolume * 100} min="0" max="100" onChange={this.handleVolumeChange} />
                                        <output className="s-volume-num s-flex-none">{parseInt(this.state.contentVolume * 100)}</output>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dialog-button-group">
                            <button className={`button w100-button`} onClick={this.handleFormSubmit} ref={button => this.buttonAdd = button}>수정</button>
                            <button className="button outline-button" onClick={this.handleClose}>취소</button>
                        </div>
                    </div>
                </CustomizedDialog>
            </>
        )
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ContentsVolume);